import React, {useState, useEffect, useContext} from 'react'
import AddInvoice from '../components/AddInvoice';
import EditInvoice from '../components/EditInvoice';
import EmployeeHeader from '../components/EmployeeHeader';
import useAxios from '../utils/useAxios';
import AuthContext from '../context/AuthContext';

function EmployeePage() {

    let [invoices, setInvoices] = useState([])
    let [counter1, setCounter1] = useState(0)
    let [invoiceToEdit, setInvoiceToEdit] = useState({})
    let [invoiceFiles, setInvoiceFiles] = useState([])
    let {user} = useContext(AuthContext)

    let [filterdInvoices, setFilteredInvoices] = useState([])
    
    let [categories, setCategories] = useState([])
    let [categoryFilter, setCategoryFilter] = useState('all')

    let [atDate, setAtDate] = useState(false)
    let [fromDateFilter, setFromDateFilter] = useState("1900-01-01")
    let [toDateFilter, setToDateFilter] = useState("2100-01-01")

    // const [nextUrl, setNextUrl] = useState([])
    // const [previousUrl, setPreviousUrl] = useState([])

    // const [currentPage, setCurrentPage] = useState('/api/employee-invoices/?page=1')


    const [search, setSearch] = useState('')


    let api = useAxios()

    const baseURL = "http://hamsieexpenses.com"
    // const baseURL = "http://hamsieexpenses.com"

    useEffect(() => {
        getInvoices()
    }, [counter1])

    let getInvoices = async () => {
        let response = await api.get('/api/employee-invoices/')
        if (response.status === 200) {
            setInvoices(response.data)


            let array = response.data
            let categoriesArray = []
            array.forEach(element => {
                if (!categoriesArray.includes(element.category)) {
                    categoriesArray.push(element.category)
                }
            })
            setCategories(categoriesArray)
        }
    }

    // let getEmployeeInvoicesForHandler = async (url) => {
    //     let response = await api.get(url)
    //     if (response.status === 200) {
    //         setInvoices(response.data.results)

    //         setNextUrl(response.data.next)
    //         setPreviousUrl(response.data.previous)

    //         let array = response.data.results
    //         let categoriesArray = []
    //         array.forEach(element => {
    //             if (!categoriesArray.includes(element.category)) {
    //                 categoriesArray.push(element.category)
    //             }
    //         })
    //         setCategories(categoriesArray)
    //     }
    // }


    let editInvoiceData = (id) => {
        let currentInvoiceToEdit = invoices.find((invoice) => invoice.id === id)
        setInvoiceToEdit(currentInvoiceToEdit)
        console.log("this is the invocie before the edits: ", currentInvoiceToEdit);
    }

    let getInvoiceFiles = async (id) => {
        let response = await api.get('/api/invoice-files/' + id)
        if (response.status === 200) {
            setInvoiceFiles(response.data)
        }
    }


    let postInvoice = async (e) => {
        e.preventDefault()
        let current_invoice_files = []
        for (let i = 0; i < e.target.invoice_files.files.length; i++) {
            current_invoice_files.push(e.target.invoice_files.files[i])
        }
        const newInvoice = {
            'name': e.target.name.value,
            'description': e.target.description.value,
            'invoice_date': e.target.invoice_date.value,
            // 'invoice_image': e.target.invoice_image.files[0],
            'invoice_files': current_invoice_files,
            'total_amount_of_invoice': e.target.total_amount_of_invoice.value,
            'amount_money_type': e.target.amount_money_type.value,
            'employee': user.user_id,
            'category': e.target.category.value,
        }
        let response = await api.post('/api/invoice/', newInvoice, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        if (response.status === 201) {
            alert("Invoice Created Successfully")
            setCounter1(counter1 + 1)
        } else {
            alert("There was something wrong please try again and make sure that you filled all the information")
        }

    }


    let patchInvoice = async (e) => {
        e.preventDefault()
        let current_invoice_files = []
        for (let i = 0; i < e.target.invoice_files.files.length; i++) {
            current_invoice_files.push(e.target.invoice_files.files[i])
        }
        let response = await api.patch('/api/invoice/' + invoiceToEdit.id, {
            'name': e.target.name.value,
            'description': e.target.description.value,
            'invoice_date': e.target.invoice_date.value,
            // 'invoice_image': e.target.invoice_image.files[0],
            'invoice_files': current_invoice_files,
            'total_amount_of_invoice': e.target.total_amount_of_invoice.value,
            'amount_money_type': e.target.amount_money_type.value,
            'employee': user.user_id,
            'category': e.target.category.value,
            'is_agree1': false,
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        if (response.status === 200) {
            alert("Invoice Edited Successfully")
        } else {
            alert("Please try again something went wrong")
        }

        setCounter1(counter1 + 1)
    }

    // const paginationHandler = (url) => {
    //     setCurrentPage(url)
    //     getEmployeeInvoicesForHandler(url)
    // } 


  return (
    <div>
        <EmployeeHeader />
        <div className='container'>

            <div className="d-flex justify-content-between">
                <div><h2>My Invoices</h2></div>
                <div><button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal">Add Invoice</button></div>
            </div>

        </div>
        <div className='container-fluid'>
            <form className="d-flex mt-5" role="search">
                <input onChange={(e) => setSearch(e.target.value)} className="form-control mr-sm-2 me-2" type="search" placeholder="Search Invoice" aria-label="Search" />
            </form>
        </div>
        <div className='container-fluid table-responsive-md'>
        <table className="table table-striped mt-5">
            <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Invoice Name</th>
                <th scope="col">Invoice Description</th>
                <th scope="col">Invoice Category
                    <select className='form-select' onChange={(e) => setCategoryFilter(e.target.value)}>
                        <option value={'all'}>All Categories</option>
                        {categories.map((category, index) => (
                            <option key={index} value={category}>{category}</option>
                        ))}
                    </select>
                </th>
                <th scope="col">Invoice Date
                <br></br>
                    <label>From:</label>
                    <input className='form-control' type="date" onChange={(e) => {setFromDateFilter(e.target.value); setAtDate(true)}} />
                    <label>To:</label>
                    <input className='form-control' type="date" onChange={(e) => {setToDateFilter(e.target.value); setAtDate(true)}} />
                </th>
                <th scope="col">Invoice Image</th>
                <th scope="col">Invoice Amount</th>
                <th scope='col'>Currency</th>
                <th scope='col'></th>
                </tr>
            </thead>
            <tbody>
                {invoices.filter((item) => {
                    if (search.toLowerCase() === "") {
                        return item
                    } else if (item.name.toLowerCase().includes(search)) {
                        return item
                    } else if (String(item.id).toLowerCase().includes(search)) {
                        return item
                    } else if (item.description.toLowerCase().includes(search)) {
                        return item
                    } else if (item.category.toLowerCase().includes(search)) {
                        return item
                    } else if (String(item.amount).toLowerCase().includes(search)) {
                        return item
                    } else if (item.amount_money_type.toLowerCase().includes(search)) {
                        return item
                    }
                    {/* return search.toLowerCase() === "" ? item: item.name.toLowerCase().includes(search) */}
                }).filter((item) => {
                    {/* let newFromDate = new Date(fromDateFilter)
                    let newToDate = new Date(toDateFilter)
                    let itemDate = new Date(item.invoice_date) */}
                    if (atDate === false) {
                        return item
                    } else {
                        if (new Date(item.invoice_date) >= new Date(fromDateFilter) && new Date(item.invoice_date) <= new Date(toDateFilter)) {
                            return item
                        }
                    }
                }).filter((item) => {
                    if (categoryFilter === 'all') {
                        return item
                    } else if (categoryFilter === item.category) {
                        return item
                    }
                }).map(invoice => {
                    if (invoice.is_agree === true) {
                        return (
                            <tr className='table-success' key={invoice.id}>
                                <th scope='row'>{invoice.id}</th>
                                <td>{invoice.name}</td>
                                <td>{invoice.description}</td>
                                <td>{invoice.category}</td>
                                <td>{invoice.invoice_date}</td>
                                <td><button className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#filesModal" onClick={() => getInvoiceFiles(invoice.id)}>Show Files</button></td>
                                <td className='text-end'>{invoice.total_amount_of_invoice}</td>
                                <td>{invoice.amount_money_type}</td>
                                <td className='text-success'>Agreed</td>
                            </tr>
                        )
                    } else if (invoice.is_agree === false && invoice.is_agree1 === true) {
                        return (
                            <tr className='table-danger' key={invoice.id}>
                            <th scope='row'>{invoice.id}</th>
                            <td>{invoice.name}</td>
                            <td>{invoice.description}</td>
                            <td>{invoice.category}</td>
                            <td>{invoice.invoice_date}</td>
                            <td><button className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#filesModal" onClick={() => getInvoiceFiles(invoice.id)}>Show Files</button></td>
                            <td className='text-end'>{invoice.total_amount_of_invoice}</td>
                            <td>{invoice.amount_money_type}</td>
                            <td><button className='btn btn-secondary' data-bs-toggle="modal" data-bs-target="#editInvoiceModal" onClick={() => editInvoiceData(invoice.id)}>Edit Invoice</button></td>
                            </tr>
                        )
                    } else {
                        return (
                            <tr key={invoice.id}>
                            <th scope='row'>{invoice.id}</th>
                            <td>{invoice.name}</td>
                            <td>{invoice.description}</td>
                            <td>{invoice.category}</td>
                            <td>{invoice.invoice_date}</td>
                            <td><button className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#filesModal" onClick={() => getInvoiceFiles(invoice.id)}>Show Files</button></td>
                            <td className='text-end'>{invoice.total_amount_of_invoice}</td>
                            <td>{invoice.amount_money_type}</td>
                            <td><button className='btn btn-secondary' data-bs-toggle="modal" data-bs-target="#editInvoiceModal" onClick={() => editInvoiceData(invoice.id)}>Edit Invoice</button></td>
                            </tr>
                        )
                    }
                }
                )}
            </tbody>
        </table>

        </div>
{/* 
        <div className='d-flex justify-content-center'>
            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    {previousUrl && 
                        <li className="page-item"><button className='page-link' onClick={() => paginationHandler(previousUrl)}>Previous</button></li>
                    }

                    {nextUrl && 
                        <li className="page-item"><button className='page-link' onClick={() => paginationHandler(nextUrl)}>Next</button></li>
                    }
                </ul>
            </nav>
        </div> */}

        <AddInvoice postInvoice={postInvoice} />
        <EditInvoice invoiceToEdit={invoiceToEdit} patchInvoice={patchInvoice} invoiceToEditCategories={{}} />

        
        <div className="modal fade" id={"filesModal"} tabIndex="-1" aria-labelledby="filesModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-body">
                    <ul className='list-group'>
                            {invoiceFiles.map(invoiceFile => (
                                <li key={invoiceFile.id} className='list-group-item'>
                                    <a target="_blank" href={baseURL + invoiceFile.invoice_file}>{invoiceFile.id} -- {invoiceFile.invoice_file.substring(1, 40)}</a>
                                </li>
                                
                            ))}
                    </ul>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EmployeePage;